module.exports = __webpack_public_path__ + "static/media/icon-status--parceiro.48ccf80c.svg";